(function() {
  'use strict';

  var overlay, form, input, results, closeBtn;
  var debounceTimer;

  function createOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'freedom-search-overlay';
    overlay.innerHTML =
      '<div class="freedom-search-overlay__inner">' +
        '<div class="freedom-search-overlay__header">' +
          '<form action="/search" method="get" class="freedom-search-overlay__form" role="search">' +
            '<input type="search" name="q" class="freedom-search-overlay__input" placeholder="Search..." autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">' +
            '<input type="hidden" name="type" value="product">' +
          '</form>' +
          '<button type="button" class="freedom-search-overlay__close" aria-label="Close search">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="freedom-search-overlay__results"></div>' +
      '</div>';

    var style = document.createElement('style');
    style.textContent =
      '.freedom-search-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.55);z-index:99999;display:none;align-items:flex-start;justify-content:center;opacity:0;transition:opacity .25s ease}' +
      '.freedom-search-overlay.is-open{display:flex;opacity:1}' +
      '.freedom-search-overlay__inner{width:100%;max-width:100%;background:#fff;margin:0;overflow-y:auto;display:flex;flex-direction:column}' +
      '.freedom-search-overlay__header{display:flex;align-items:center;border-bottom:1px solid #e5e5e5;padding:16px 20px;gap:12px}' +
      '.freedom-search-overlay__form{flex:1;display:flex}' +
      '.freedom-search-overlay__input{width:100%;border:none;outline:none;font-family:"Pretendard",sans-serif;font-size:16px;font-weight:300;letter-spacing:.02em;padding:8px 0;background:transparent;-webkit-appearance:none}' +
      '.freedom-search-overlay__input::placeholder{color:#999}' +
      '.freedom-search-overlay__close{background:none;border:none;cursor:pointer;padding:4px;color:#000;display:flex;align-items:center}' +
      '.freedom-search-overlay__results{padding:0 20px 20px}' +
      '.freedom-search-overlay__results:empty{padding:0}' +
      '.freedom-search-result{display:flex;align-items:center;gap:16px;padding:14px 0;border-bottom:1px solid #f0f0f0;text-decoration:none;color:#000}' +
      '.freedom-search-result:last-child{border-bottom:none}' +
      '.freedom-search-result__img{width:60px;height:60px;object-fit:cover;flex-shrink:0;background:#f5f5f5}' +
      '.freedom-search-result__info{flex:1;min-width:0}' +
      '.freedom-search-result__title{font-family:"Pretendard",sans-serif;font-size:14px;font-weight:400;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.freedom-search-result__price{font-family:"Pretendard",sans-serif;font-size:13px;font-weight:300;color:#666}' +
      '.freedom-search-overlay__no-results{font-family:"Pretendard",sans-serif;font-size:14px;color:#666;padding:20px 0;text-align:center}' +
      '.freedom-search-overlay__view-all{display:block;text-align:center;padding:16px 0 0;font-family:"Pretendard",sans-serif;font-size:13px;font-weight:400;color:#000;text-decoration:underline;text-underline-offset:3px}' +
      '';

    document.head.appendChild(style);
    document.body.appendChild(overlay);

    form = overlay.querySelector('.freedom-search-overlay__form');
    input = overlay.querySelector('.freedom-search-overlay__input');
    results = overlay.querySelector('.freedom-search-overlay__results');
    closeBtn = overlay.querySelector('.freedom-search-overlay__close');

    closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeSearch();
    });

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function() { fetchResults(q); }, 300);
    });

    form.addEventListener('submit', function(e) {
      var q = input.value.trim();
      if (!q) e.preventDefault();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });
  }

  function openSearch() {
    if (!overlay) createOverlay();
    var header = document.getElementById('header');
    var top = header ? header.getBoundingClientRect().bottom : 0;
    overlay.style.paddingTop = top + 'px';
    overlay.querySelector('.freedom-search-overlay__inner').style.maxHeight = 'calc(100vh - ' + top + 'px)';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 100);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
  }

  function fetchResults(query) {
    var params = '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][fields]=title,product_type,vendor,tag,sku';
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'search/suggest.json' + params
      : '/search/suggest.json' + params;

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        renderResults(products, query);
      })
      .catch(function() {
        results.innerHTML = '<p class="freedom-search-overlay__no-results">Something went wrong. Try again.</p>';
      });
  }

  function renderResults(products, query) {
    if (!products.length) {
      results.innerHTML = '<p class="freedom-search-overlay__no-results">No results for "' + escapeHtml(query) + '"</p>';
      return;
    }

    var html = '';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var imgSrc = p.image || p.featured_image && p.featured_image.url || '';
      var price = p.price ? formatMoney(p.price) : '';
      html +=
        '<a href="' + p.url + '" class="freedom-search-result">' +
          (imgSrc ? '<img class="freedom-search-result__img" src="' + imgSrc + '" alt="" loading="lazy">' : '') +
          '<div class="freedom-search-result__info">' +
            '<p class="freedom-search-result__title">' + escapeHtml(p.title) + '</p>' +
            (price ? '<p class="freedom-search-result__price">' + price + '</p>' : '') +
          '</div>' +
        '</a>';
    }
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="freedom-search-overlay__view-all">View all results</a>';
    results.innerHTML = html;
  }

  /**
   * Predictive Search API returns product price as a DECIMAL in the shop currency
   * (see Shopify docs: product_object.price), not cents.
   */
  function formatMoney(value) {
    if (value == null || value === '') return '';
    var num = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (isNaN(num)) return '';
    var str = num.toFixed(2);
    var decParts = str.split('.');
    var intWithCommas = decParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCommaSep = decParts.length > 1 ? intWithCommas + '.' + decParts[1] : intWithCommas;
    var fmt = typeof window.shopMoneyFormat === 'string' ? window.shopMoneyFormat : '';
    if (fmt) {
      var out = fmt
        .replace(/\{\{\s*amount\s*\}\}/g, str)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(num)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSep)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intWithCommas);
      if (!/\{\{/.test(out)) return out;
    }
    return '$' + str;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var triggers = document.querySelectorAll('[data-search-open]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function(e) {
        e.preventDefault();
        openSearch();
      });
    }
  });
})();
